export const WIRES_CROSSED = 'Whoops, some wires got crossed';
export const TRY_AGAIN =
  'Sorry for the error, please try again now or try later';
export const TAKE_ME_BACK = 'Thanks, take me back';
